<template>
  <div id="app">
    <router-view />
    <el-dialog class="TNYdia TNYdiaSmall" :visible.sync="isTeaNewYear"
      v-if="isTeaNewYear && new Date().getTime() < 1738710000000" :before-close="handleClose">
      <div class="isTeaNewYearbx">
        <img src="https://file.icve.com.cn/file_doc/469/376/7565E0647D558198772974EA5DA0040B.png" alt="">
        <i @click="handleClose()" class="el-icon-circle-close"></i>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
    data() {
    return {
        isTeaNewYear: true, 
      }
    },
    created() {
      
  },
  methods: {
    handleClose(done) {
      // localStorage.setItem('isTeaNewYear', 'false')
      this.isTeaNewYear = false
    },
  },

}
</script>
<style lang="scss" scoped>
#app {
  width: 100vw;
  height: 100vh;
  background-color: #09121D;
  // background-color: green;
  // overflow: hidden;
}
#app > div {
  height: 100vh;
}
.TNYdia {
  .TeaNewYearbox {
    width: 50vh;
    height: 99vh;
  }

  .isTeaNewYearbx {
    text-align: center;


    img {
      width: 50vh;
      cursor: pointer;
    }

    .el-icon-circle-close {
      margin-top: 20px;
      font-weight: 300;
      font-size: 50px;
      color: rgba(255, 255, 255, 0.7);
      cursor: pointer;
    }
  }

  ::v-deep .el-dialog {
    width: 50vh;
    background: rgba(0, 0, 0, 0);
    box-shadow: none;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
      border-radius: 20px;
    }
  }
}
</style>